import { publicApi, api } from './axios'; // ← отдельный экземпляр без interceptors 401
import { setAccessToken, setRefreshToken, clearAccessToken, clearRefreshToken, refreshSession } from './token';

export const authApi = {
    login: async (payload) => {
        const response = await publicApi.post('/auth/login', payload);
        const { accessToken, refreshToken } = response.data;
        setAccessToken(accessToken);
        if (refreshToken) setRefreshToken(refreshToken);
        return response.data;
    },

    register: async (payload) => {
        const response = await publicApi.post('/auth/register', payload);
        const { accessToken, refreshToken } = response.data;
        if (accessToken) setAccessToken(accessToken);
        if (refreshToken) setRefreshToken(refreshToken);
        return response.data;
    },

    // Реэкспорт — нет дублирования
    refresh: refreshSession,

    logout: async () => {
        try {
            await api.post('/auth/logout');
        } catch {
            // Игнорируем ошибки сети/аутентификации
        }
        clearAccessToken();
        clearRefreshToken();
    },

    // 🔴 Этап 1: Восстановление пароля
    forgotPassword: async (email) => {
        if (!email) throw new Error('Email is required');
        const response = await publicApi.post('/auth/forgot-password', { email });
        return response.data;
    },

    resetPassword: async (token, password, confirmPassword) => {
        if (!token) throw new Error('Token is required');
        if (!password) throw new Error('Password is required');
        if (!confirmPassword) throw new Error('Confirm password is required');
        const response = await publicApi.post(`/auth/reset-password/${token}`, { password, confirmPassword });
        return response.data;
    },

    confirmEmail: async (token) => {
        if (!token) throw new Error('Token is required');
        // Кодируем токен, чтобы спецсимволы не ломали путь запроса
        const response = await publicApi.get(`/auth/confirmation/${encodeURIComponent(token.trim())}`);
        return response.data;
    },

    updatePassword: async (password, confirmPassword) => {
        if (!password) throw new Error('Password is required');
        if (!confirmPassword) throw new Error('Confirm password is required');
        const response = await api.post('/auth/update-password', { password, confirmPassword });
        return response.data;
    },

    /**
     * Повторная отправка письма подтверждения email
     * @param {string} email - Email пользователя
     * @returns {Promise<Object>}
     */
    resendConfirmation: async (email) => {
        if (!email) throw new Error('Email is required');
        const response = await api.post('/auth/resend-confirmation', { email });
        return response.data;
    }
};